var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.667L2.69488 12.2192C3.45333 14.3681 3.83257 15.4426 4.69785 16.0548C5.56313 16.667 6.70258 16.667 8.98148 16.667H11.0186C13.2974 16.667 14.4369 16.667 15.3022 16.0548C16.1674 15.4426 16.5467 14.3681 17.3052 12.2192L17.5 11.667",
    stroke: "#616874",
    strokeWidth: 1.76,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 11.6673V3.33398M10.0003 11.6673C9.41681 11.6673 8.3266 10.0054 7.91699 9.58398M10.0003 11.6673C10.5838 11.6673 11.6741 10.0054 12.0836 9.58398",
    stroke: "#616874",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownload);
export default __webpack_public_path__ + "static/media/report-download.b7b02c8b47e4a6acd01a20a4ee9a7d96.svg";
export { ForwardRef as ReactComponent };